import { mainApi } from "services/main";

export interface SearchGaiaObjectRequest {
  teamName: string;
  category: string;
  propertyFilterQuery?: {
    operation: string;
    tokens?: {
      propertyKey: string;
      operator: string;
      value?: string;
      values?: string[];
    }[];
  };
  page?: number;
  pageSize?: number;
  sortBy?: string;
  sortOrder?: string;
  includeOutcomeBreakdowns?: boolean;
}

export interface GaiaObjectSearchResult {
  gaiaObjectId: string;
  shortId: string;
  category: string;
  title: string;
  teamName: string;
  customAttributesDataMap?: Record<string, string>;
  createdBy?: string;
  modifiedBy?: string;
  createdAt?: string;
}

export interface SearchGaiaObjectResponse {
  gaiaObjects: GaiaObjectSearchResult[];
  paginationMetadata: {
    currentPage: number;
    pageSize: number;
    totalCount: number;
    totalPages?: number;
    searchAfter?: string[];
  };
  outcomeBreakdowns?: {
    outcomeBreakdownId: string;
    parentId: string;
    gaiaObjectId?: string;
    paymentId?: string;
    type: string;
    category: string;
    totalTaxAmount: string;
    totalPenaltyAmount: string;
    totalInterestAmount: string;
    totalOtherAmount: string;
    dueDate?: number | string;
    additionalInformation?: string;
    superseded?: boolean;
  }[];
}

const extendedApi = mainApi.injectEndpoints({
  endpoints: (builder) => ({
    searchGaiaObjects: builder.query<
      SearchGaiaObjectResponse,
      SearchGaiaObjectRequest
    >({
      query: (params) => ({
        url: "/gaia-objects-search",
        method: "POST",
        body: params,
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useLazySearchGaiaObjectsQuery } = extendedApi;
